module.exports = __webpack_public_path__ + "tile-5-image-Bi-Xuov.webp";